import {
    favoriteChannelsEndpoint,
    markFavoriteEndpoint,
    unMarkFavoriteEndpoint,
} from '@/api/toya/apiConstantsCodespot'
import { getWithAuth, postWithAuth, putWithAuth } from '@/api/httpRequests'
import Channel from '@/clients/toya/classes/channels/channel'

import { getErrorMessage } from '@/shared/lib'

export const getApiFavorites = async (profileId: string) => {
    try {
        const res = await getWithAuth(
            `${favoriteChannelsEndpoint}/${profileId}`,
            false
        )

        if (!res) return

        const { response } = res

        return response.channels
    } catch (error) {
        getErrorMessage('request', error)
        throw new Error('fetch favorites list failure')
    }
}

export const updateApiFavoritesChannel = async (
    channels: Channel[],
    profileId: string
) => {
    try {
        const requestBody = {
            channels,
        }
        const stringifiedBody = JSON.stringify(requestBody)
        await putWithAuth(
            `${favoriteChannelsEndpoint}/${profileId}`,
            false,
            stringifiedBody
        )
    } catch (error) {
        getErrorMessage('request', error)
        throw new Error('update favorites list failure')
    }
}

export const markApiFavoriteItem = async (
    profileId: string,
    productType: string,
    productId: string
) => {
    try {
        const requestBody = { productId, productType }
        const stringifiedBody = JSON.stringify(requestBody)
        await postWithAuth(
            `${markFavoriteEndpoint}/${profileId}`,
            true,
            stringifiedBody,
            profileId
        )
    } catch (error) {
        getErrorMessage('request', error)
        throw new Error('mark channel as favorite failure')
    }
}

export const unMarkApiFavoriteItem = async (
    productId: string,
    profileId: string,
    productType: string
) => {
    try {
        const requestBody = {
            productType,
            productId,
        }
        const stringifiedBody = JSON.stringify(requestBody)
        await postWithAuth(
            `${unMarkFavoriteEndpoint}/${profileId}`,
            true,
            stringifiedBody
        )
    } catch (error) {
        getErrorMessage('request', error)
        throw new Error('un mark channel as favorite failure')
    }
}
